var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mixes)?_c('BaseSection',{attrs:{"padded":""}},[_c('MixGridBlock',{attrs:{"mixes":_vm.mixes}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }